export default function debounce(fn, wait = 300) {
  const context = this
  if (Object.prototype.toString.call(fn) !== '[object Function]') return
  return function debounced(args) {
    if (context.timer) {
      clearTimeout(context.timer)
      context.timer = null
    }
    context.timer = setTimeout(() => {
      fn(args)
    }, wait)
  }
}
